import * as Sentry from "@sentry/browser";

import { getAptConfig } from "client/config";
import { SENTRY_DSN } from "client/constants";
import { getSessionId } from "client/utils/session";

export const initializeSentry = (
  scopeProperties: {
    [key: string]: string;
  } = {}
): void => {
  Sentry.init({
    beforeSend(event, hint) {
      // https://github.com/getsentry/sentry-javascript/issues/2514
      if (hint?.originalException === "Timeout") {
        return null;
      }
      return event;
    },
    dsn: SENTRY_DSN,
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      // r.beacon illegal invocation
      // gtm => fbq error
      /googletagmanager\.com\/gtm.js/i,
      // r.beacon illegal invocation
      /munchkin\.marketo\.net/i,
      // pagead/viewthroughconversion errors
      /googleads\.g\.doubleclick\.net/i,
      // onetrust
      /onetrust\.com/i,
    ],
    environment: getAptConfig("SENTRY_ENVIRONMENT") ?? "development",
    integrations: [],
  });

  Sentry.configureScope((scope: any) => {
    scope.setTag("session_id", getSessionId());
    scope.setTag("app_version", "redesign");
    Object.entries(scopeProperties).forEach((entry) => scope.setTag(...entry));
  });
};
